import { BubbleSort } from './BubbleSort';
import { SelectionSort } from './SelectionSort';
import { InsertionSort } from './InsertionSort';
import { MergeSort } from './MergeSort';
import { QuickSort } from './QuickSort';
import { HeapSort } from './HeapSort';
import { ShellSort } from './ShellSort';

export const Algorithms = [
  new BubbleSort(),
  new SelectionSort(),
  new InsertionSort(),
  new MergeSort(),
  new QuickSort(),
  new HeapSort(),
  new ShellSort(),
];

export { BubbleSort, SelectionSort, InsertionSort, MergeSort, QuickSort, HeapSort, ShellSort };
